import { getJSONStorage } from '../storage';
import StorageKeys from '../storage/storageKeys';
import { getCacheKey, getData, isCacheKey, isStale, setData, setMeta, } from './utils';
/**
 * Cache structure
 *
 * {
 *    <hash_key>: {
 *      __meta__: {
 *        expiresAt: ExpiresAt;
 *      }
 *      data,
 *    }
 * }
 */
const storage = getJSONStorage(StorageKeys.cachePrefix.scope);
const Cache = {
    has(key) {
        const cacheKey = getCacheKey(key);
        const exists = storage.contains(cacheKey);
        if (!exists) {
            return false;
        }
        const cachedValue = storage.get(cacheKey);
        if (isStale(cachedValue)) {
            storage.delete(cacheKey);
            return false;
        }
        return true;
    },
    get(key) {
        if (this.has(key)) {
            const cacheKey = getCacheKey(key);
            const cachedValue = storage.get(cacheKey);
            return getData(cachedValue);
        }
        return undefined;
    },
    set(key, data, ttl /* in seconds */) {
        const cacheValue = setData(setMeta({}, {
            expiresAt: Date.now() + ttl * 1000,
        }), data);
        storage.set(getCacheKey(key), cacheValue);
    },
    evictStale() {
        const cacheKeys = storage.getAllKeys().filter(isCacheKey);
        cacheKeys.forEach(key => {
            const value = storage.get(key);
            if (isStale(value)) {
                storage.delete(key);
            }
        });
    },
};
export default Cache;
